import React from "react";
import PropTypes from "prop-types";
import Badge from "@dtci/spellbook/Badge";
import Tooltip from "@dtci/spellbook/Tooltip";

const PPTBadgeList = ({ value, maxItems }) => {
  if (value == null || (Array.isArray(value) && value.length === 0)) {
    return "—";
  }

  const values = Array.isArray(value) ? value : [value];
  const labels = values.map((v) => v.name || v);

  // If no maxItems specified, show all badges
  if (!maxItems || labels.length <= maxItems) {
    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
        {labels.map((labelValue, index) => (
          <Badge key={index} color="base" light={true}>
            {labelValue}
          </Badge>
        ))}
      </div>
    );
  }

  // Show truncated list with "+n" badge and hover tooltip
  const visibleLabels = labels.slice(0, maxItems);
  const hiddenCount = labels.length - maxItems;

  // Create tooltip content showing all items
  const tooltipContent = (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      {labels.map((labelValue, index) => (
        <div key={index}>{labelValue}</div>
      ))}
    </div>
  );

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 5, alignItems: "center" }}>
      {visibleLabels.map((labelValue, index) => (
        <Badge key={index} color="base" light={true}>
          {labelValue}
        </Badge>
      ))}
      <Tooltip
        tooltipContent={tooltipContent}
        tippyProps={{
          placement: "top",
          trigger: "mouseenter focus",
          zIndex: 9999, // Ensure tooltip appears above AG Grid cells
          appendTo: () => document.body, // Render in body to avoid clipping
        }}
      >
        <span style={{ display: "inline-flex", cursor: "help" }}>
          <Badge color="base" light={true}>
            +{hiddenCount}
          </Badge>
        </span>
      </Tooltip>
    </div>
  );
};

PPTBadgeList.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ name: PropTypes.string }),
    PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({ name: PropTypes.string }),
      ]),
    ),
  ]),
  maxItems: PropTypes.number,
};

export default PPTBadgeList;
